// src/services/transactionService.js
import { authFetch } from "../utils/api";

export const fetchTransactionById = async (type, id) => {
    let endpoint = type === 'Facture' ? 'factures' : 'operations';
    const url = `/${endpoint}/${id}`; 
    
    try {
        // ⭐ Utilisation de .get()
        const response = await authFetch.get(url); 
        
        if (!response.ok) {
            const errorBody = await response.text(); 
            throw new Error(`Échec du chargement de la transaction ${id}. Réponse API: ${errorBody}`);
        }
        return response.json();
    } catch (error) {
        console.error("❌ Erreur dans fetchTransactionById:", error);
        throw error;
    }
};

// Si tu as d'autres fonctions comme deleteTransaction dans ce service :
export const deleteTransaction = async (type, id) => {
    let endpoint = type === 'Facture' ? 'factures' : 'operations';
    const response = await authFetch.delete(`/${endpoint}/${id}`);
    if (!response.ok) throw new Error("Erreur lors de la suppression");
    return response.json();
};